import React from "react";
import { emitter, EmitterListeners } from "../EventEmitter";

export const useEventEmitterOnListener = (
  event: EmitterListeners,
  listener: ((...args: unknown[]) => unknown) | undefined,
) => {
  React.useEffect(() => {
    if (!listener) return;
    emitter.on(event, listener);
    // eslint-disable-next-line consistent-return
    return function cleanup() {
      emitter.off(event, listener);
    };
  }, [event, listener]);
};
